<div class="main-wrapper">
	<div class="main-content">
		<ng-container *ngIf="_likutWarehouse.buttonsAndText$ | async as buttonsAndText">
			<header class="header">
				<div class="content">
					<div class="header__block row">
						<div class="header__arrow col image no-print" (click)="handleNavigation()">
							<img src="/assets/images/header/back-arrow.svg" alt="arrow" />
						</div>
						<div class="header__title col">{{ title$ | async | buttonText }}</div>
						<div class="header__burger col image no-print" *ngIf="shouldDisplaySearchAndFilterAndReset$ | async" (click)="Restart()" style="text-decoration: underline">
							<b> {{ buttonsAndText['inventory-report-reset'] | buttonText }} </b>
						</div>
					</div>
				</div>
				<div class="report-table__row no-print" *ngIf="shouldDisplaySearchAndFilterAndReset$ | async">
					<div class="header__search header__search_small" style="width: 99%; margin: auto; margin-top: 10px">
						<form [formGroup]="form">
							<input
								class="header__search-input"
								type="text"
								[placeholder]="buttonsAndText['inventory-report-search-placeholder'] | buttonText"
								formControlName="search"
								id="search-Input"
								style="text-align: center; direction: rtl"
							/>
						</form>
						<button class="header__clear-icon" (click)="clearSearch()"></button>
					</div>
					<div class="total-shown no-print">
						<span>מציג {{ totalLines$ | async | number }} שורות</span>
						<ng-container *ngIf="shouldDisplayTotalPackAndInStock$ | async">
							<span> | {{ totalPackQTY$ | async | number }} באריזה </span>
							<span> | {{ totalInStock$ | async | number }} במלאי </span>
						</ng-container>
					</div>
				</div>
			</header>
			<ng-container *ngIf="selectedLines$ | async as selectedLines">
				<div class="popup" *ngIf="isPopupOpen$ | async" style="z-index: 555">
					<div class="overlay" (click)="resolveHandlePopupClick(null)"></div>
					<div class="product-detail__title">
						{{ popupTitle$ | async }}
					</div>
					<div class="product-detail__title remarks" *ngIf="isHistoryPopupOpen$ | async">
						<button mat-raised-button (click)="prepareToSendData()">{{ buttonsAndText['inventory-scan-send-action'] | buttonText }}</button>
					</div>
					<div class="product-detail-popup popup__content">
						<div class="popup__close" (click)="resolveHandlePopupClick(null)" style="width: 30px; height: 30px; background-color: black"></div>
						<div class="product-detail__wrapper custom-scrollbar no-gutter">
							<table>
								<thead class="fixed-table-headers">
									<tr>
										<th *ngFor="let header of popupHeaders$ | async">{{ buttonsAndText[header.textID] | buttonText }}</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let line of selectedLines" [appSetTextColorToFitBackgroundContrast]="line.color" [ngStyle]="{ background: line.color || 'initial' }">
										<td *ngFor="let data of popupHeaders$ | async">
											<button mat-icon-button style="background: white" (click)="removeScannedPallet(line.PaletteID)" *ngIf="data.isButton && line.isScanned">
												<mat-icon color="primary">close</mat-icon>
											</button>
											{{ data.isButton ? '' : data.isDate ? (line[data.key] | date : 'dd/MM/yy' : 'GMT') : line[data.key] }}
										</td>
										<!-- <td *ngIf="shouldDisplayRemarkColumn$ | async">
											{{ line['Remark'] }}
										</td> -->
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="selectedLinesPalletMovementsDisplay$ | async as selectedLines">
				<div class="popup" *ngIf="isPalletMovementsPopupOpen$ | async" style="z-index: 555">
					<div class="overlay" (click)="resolveHandlePopupClick(null)"></div>
					<div class="product-detail-popup popup__content">
						<div class="popup__close" (click)="resolveHandlePopupClick(null)" style="width: 30px; height: 30px; background-color: black"></div>
						<div class="product-detail__wrapper custom-scrollbar no-gutter">
							<table>
								<thead class="fixed-table-headers">
									<tr>
										<th *ngFor="let header of popupHeaders$ | async">{{ buttonsAndText[header.textID] | buttonText }}</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let line of selectedLines" [appSetTextColorToFitBackgroundContrast]="line.Color" [ngStyle]="{ background: line.Color }">
										<td *ngFor="let data of popupHeaders$ | async">
											{{ data.isDate ? (line[data.key] | date : 'dd/MM/yy HH:mm' : 'GMT') : data.shouldTranslateCount ? (line[data.key] | countToText) : line[data.key] }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</ng-container>
			<section class="dashboard-tables" style="margin-top: 30px">
				<div class="content">
					<div class="dashboard-tables__wrapper">
						<div class="dashboard-tables__row dashboard-tables__row_scroll margin-top">
							<form [formGroup]="form" class="flex justify-center" dir="rtl" *ngIf="shouldDisplaySearchAndFilterAndReset$ | async; else inventoryScanSubmitBlock">
								<mat-form-field style="font-size: 18px">
									<mat-label>{{ buttonsAndText['inventory-report-warehouse-select-label'] | buttonText }}</mat-label>
									<mat-select formControlName="warehouses" multiple>
										<mat-option *ngFor="let warehouse of warehouses$ | async" [value]="warehouse">
											{{ warehouse }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</form>
							<div class="info-row" *ngIf="isExcelButtonVisible$ | async">
								<ng-container *ngIf="shouldDisplayExcelRadioGroup$ | async; else excelButtonBlockWithRadioSelectBlock">
									<app-excel-button onlyEmit (clicked)="downloadExcel()"></app-excel-button>
									<mat-radio-group color="primary" [formControl]="excelRadioControl" class="justify-align-center gap" dir="rtl">
										<mat-radio-button *ngFor="let button of radioButtons" [value]="button.value">{{ button.text }}</mat-radio-button>
									</mat-radio-group>
								</ng-container>
								<ng-template #excelButtonBlockWithRadioSelectBlock>
									<app-excel-button></app-excel-button>
								</ng-template>
							</div>
							<h3 class="text-align-center" *ngIf="specificMovementID$ | async as specificMovement">ספירת מלאי מס': {{ specificMovement }}</h3>
							<ng-template #inventoryScanSubmitBlock>
								<div class="flex justify-center" *ngIf="anyScanned$ | async" style="margin-bottom: 30px">
									<button mat-raised-button color="primary" (click)="isHistoryPopupOpen$.next(true)">{{ openScanHistoryButtonTitle$ | async }}</button>
								</div>
								<div class="flex justify-align-center flex-column gap">
									<button mat-icon-button (click)="isBarcodePopupOpen$.next(true)">
										<mat-icon style="color: var(--valid-color)">add_circle</mat-icon>
									</button>
									<span>סה"כ נסרקו {{ totalValidScans$ | async }} / {{ (inventory$ | async).length }}</span>
								</div>
							</ng-template>
							<b>
								<section class="sticky-headers">
									<table class="report-table__table" [ngStyle]="{ height: 'calc(99vh - ' + (tableHeight || 0) + ')' }" cellspacing="0">
										<thead class="report-table__table-head" #thead>
											<tr style="height: 54px">
												<ng-container *ngIf="_likutWarehouse.buttonsAndText$ | async as buttonsAndText">
													<th [class]="header.headerClass" *ngFor="let header of headers$ | async">
														{{ buttonsAndText[header.textID] | buttonText }}
													</th>
												</ng-container>
											</tr>
										</thead>
										<tbody class="report-table__table-body" [ngStyle]="{ height: 'calc(99vh - ' + thead.offsetHeight + 'px - ' + (tableHeight || 1) + ')' }">
											<tr
												*ngFor="let row of displayValuesPerPageMode$ | async"
												(click)="resolveHandlePopupClick(row)"
												[ngStyle]="{ background: getBackgroundColor(row) }"
												[appSetTextColorToFitBackgroundContrast]="getBackgroundColor(row)"
											>
												<td *ngFor="let data of headers$ | async" [class]="data.bodyClass + ' relative'">
													{{ data.isDate ? (row[data.key] | date : 'dd/MM/yy' : 'GMT') : row[data.key] }}
													<mat-icon style="position: absolute; left: 10%; top: 50%; transform: translateY(-50%); color: var(--valid-color)" *ngIf="data.displayValid && row.isScansValid"
														>check</mat-icon
													>
												</td>
											</tr>
										</tbody>
									</table>
								</section>
							</b>
						</div>
					</div>
				</div>
			</section>
			<div class="popup" *ngIf="isBarcodePopupOpen$ | async" style="z-index: 555">
				<div class="overlay" (click)="isBarcodePopupOpen$.next(false)"></div>
				<div class="product-detail-popup popup__content">
					<div class="popup__close" (click)="isBarcodePopupOpen$.next(false)" style="width: 30px; height: 30px; background-color: black"></div>
					<div class="product-detail__wrapper" style="padding: 20px">
						<form [formGroup]="barcodePopupForm" dir="rtl" class="flex flex-column justify-align-center" (ngSubmit)="onBarcodeFormSubmit()">
							<mat-form-field>
								<mat-label>{{ buttonsAndText['inventory-scan-barcode-label'] | buttonText }}</mat-label>
								<input matInput formControlName="barcode" #barcodeInput />
							</mat-form-field>
							<div class="flex justify-around row">
								<button mat-raised-button style="background: var(--valid-color)">{{ buttonsAndText['inventory-scan-scan-action'] | buttonText }}</button>
								<button mat-raised-button type="button" color="primary" (click)="isBarcodePopupOpen$.next(false)">{{ buttonsAndText['close-button'] | buttonText }}</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>
